import { NavLink, Outlet, useParams } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../store/store"
import Header from "../../components/Header"
import { useEffect, useState } from "react"
import { getTeam } from "../../services/team.services"
import { toast } from "react-toastify"
import { setTeam } from "../../store/features/teamSlice"
import Loader from "../../components/Loader"
import config from "../../config"
import { Check, X } from "lucide-react"
import JoinTeamButton from "../../components/JoinTeamButton"
import UpdateTeamDataForm from "./UpdateTeamDataForm"
import TeamLogo from "./TeamLogo"

const NavigationItem: React.FC<{ to?: string, title: string }> = ({ to = "/", title }) => {
    return <NavLink end className={({ isActive }) => `rounded-t-lg ${isActive ? "text-white bg-[#459cff]" : "bg-transparent text-zinc-700"} px-5 py-2`} to={to}>{title}</NavLink>
}

const TeamNavigation = () => {
    const team = useAppSelector(state => state.team)
    const player = useAppSelector(state => state.player)
    const isMember = player.teams?.find((member) => member.team_id === team.id)

    return (
        <div className="px-5 md:px-32 flex items-center gap-5 bg-gray-50 border-b-2 border-b-[#459cff] overflow-x-auto">
            <NavigationItem to={`/teams/${team.slug}`} title="General" />
            <NavigationItem to={`/teams/${team.slug}/members`} title="Miembros" />
            <NavigationItem to={`/teams/${team.slug}/timeline`} title="Historia" />
            {isMember && isMember.admin && <NavigationItem to={`/teams/${team.slug}/contracts`} title="Contratos" />}
            {isMember && isMember.admin && <NavigationItem to={`/teams/${team.slug}/wallet`} title="Billetera" />}
        </div>
    )
}

const TeamsTemplate = () => {
    const { teamSlug } = useParams()
    const team = useAppSelector(state => state.team)
    const player = useAppSelector(state => state.player)
    const dispatch = useAppDispatch()


    const [loading, setLoading] = useState<boolean>(true)
    const [notFound, setNotFound] = useState<boolean>(false)


    const isMember = player.teams?.find((member) => member.team_id === team.id)

    useEffect(() => {
        getTeam({ teamSlug: teamSlug as string })
            .then((res) => {
                if (res.data.payload.team === null) {
                    setNotFound(true)
                    return
                }
                dispatch(setTeam(res.data.payload.team))
            })
            .catch((error) => toast.error(error.response.data.message))
            .finally(() => {
                setLoading(false)
            })
    }, [])

    if (loading) return <Loader />

    if (!loading && notFound) return <p className="text-zinc-700 text-xl">No sé encontró el equipo.</p>

    return (
        <div>
            <Header className="flex flex-col gap-5 bg-gray-50">
                <div className="flex flex-col md:flex-row items-center md:justify-between gap-5">
                    <div className="flex flex-col md:flex-row items-center gap-5 md:gap-10">
                        <TeamLogo />
                        <div className="flex flex-col gap-2 max-w-[500px]">
                            <p className="text-zinc-700 font-extrabold text-4xl text-center md:text-left">{team?.name}</p>
                            {team?.description && <p className="text-zinc-700 text-center md:text-left">{team?.description}</p>}
                            <UpdateTeamDataForm />
                        </div>
                    </div>

                    <JoinTeamButton />
                </div>
            </Header>

            <TeamNavigation />

            <Outlet />
        </div>
    )
}


export default TeamsTemplate